/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Search';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const SearchIcon = withMuiAdapter(Base, 'Search');
